import React, { Component } from 'react'
import { Input, Form, Modal, Popconfirm, Button, Select } from 'antd'

const FormItem = Form.Item
const { TextArea } = Input
const Option = Select.Option

class AddEditForm extends Component {
  handleCreateTask = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.handleAddTask(values)
      form.resetFields()
    })
  }

  handleEditTask = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      this.props.handleEditTask(values)
      form.resetFields()
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.props.handleToggleAddEditForm()
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { modalVisible, currentTask } = this.props
    return (
      <Modal
        visible={modalVisible}
        title="Task"
        okText={currentTask ? 'Save Changes' : 'Add Task'}
        onCancel={this.handleCancel}
        onOk={currentTask ? this.handleEditTask : this.handleCreateTask}
        width={currentTask ? '90%' : 800}
        maskClosable={false}
      >
        <Form layout="vertical">
          {currentTask && (
            <div class="pb-3">
              <div className="row">
                <div class="col-6">Created By:</div>
                <div class="col-6">Updated By:</div>
              </div>
              <div className="row">
                <div class="col-6">
                  <strong>{`${currentTask.first_name_created_by} ${
                    currentTask.last_name_created_by
                  }`}</strong>
                </div>
                <div class="col-6">
                  <strong>{`${currentTask.first_name_updated_by} ${
                    currentTask.last_name_updated_by
                  }`}</strong>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Name">
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      message: 'Name cannot be blank.'
                    }
                  ],
                  initialValue: currentTask ? currentTask.name : ''
                })(<Input placeholder="Enter name..." />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Type">
                {getFieldDecorator('type', {
                  rules: [
                    {
                      required: true,
                      message: 'Type cannot be blank.'
                    }
                  ],
                  initialValue: currentTask ? currentTask.type : ''
                })(
                  <Select>
                    <Option value="Construction">Construction</Option>
                    <Option value="Adjuster">Adjuster</Option>
                  </Select>
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  initialValue: currentTask ? currentTask.description : ''
                })(<TextArea placeholder="Describe the task..." rows={4} />)}
              </FormItem>
            </div>
          </div>
        </Form>
        {currentTask && (
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={this.props.handleDeleteTask}
            onCancel={this.cancelDelete}
            okText="Yes"
            cancelText="No"
          >
            {currentTask && <Button type="danger" icon="delete" />}
          </Popconfirm>
        )}
      </Modal>
    )
  }
}

export default Form.create()(AddEditForm)



// WEBPACK FOOTER //
// ./src/components/tasks/AddEditForm.js